module.exports = __webpack_public_path__ + "img/21.e631700e.jpg";